import { useState } from 'react';

interface ChatSuggestionCardProps {
  type: 'water_interval';
  value: number;
  onAccept: () => Promise<void>;
}

export function ChatSuggestionCard({ type, value, onAccept }: ChatSuggestionCardProps) {
  const [accepting, setAccepting] = useState(false);
  const [accepted, setAccepted] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [error, setError] = useState(false);

  if (dismissed) return null;

  if (accepted) {
    return (
      <div className="ml-2 mt-1 inline-flex items-center gap-1.5 px-3 py-1.5 bg-success/10 border border-success/30 rounded-lg text-xs font-sans text-success">
        <span className="material-symbols-outlined text-sm" aria-hidden="true">check_circle</span>
        Schedule updated
      </div>
    );
  }

  const label = type === 'water_interval'
    ? `Water every ${value} day${value !== 1 ? 's' : ''}`
    : '';

  return (
    <div className="ml-2 mt-1 flex items-center gap-2 px-3 py-2 bg-primary/5 border border-primary/20 rounded-lg">
      <span className="material-symbols-outlined text-primary text-base" aria-hidden="true">water_drop</span>
      <span className="text-xs font-sans font-medium text-editorial-black flex-1">
        {error ? <span className="text-danger">Failed — try again</span> : label}
      </span>
      <button
        type="button"
        onClick={async () => {
          setAccepting(true);
          setError(false);
          try {
            await onAccept();
            setAccepted(true);
          } catch {
            setError(true);
          } finally {
            setAccepting(false);
          }
        }}
        disabled={accepting}
        className="text-xs font-sans font-bold text-primary uppercase tracking-wider hover:brightness-90 transition-colors disabled:opacity-50"
        aria-label={`Accept: ${label}`}
      >
        {accepting ? '...' : error ? 'Retry' : 'Apply'}
      </button>
      <button
        type="button"
        onClick={() => setDismissed(true)}
        className="text-xs font-sans text-gray-400 hover:text-gray-600 transition-colors"
        aria-label="Dismiss suggestion"
      >
        <span className="material-symbols-outlined text-base" aria-hidden="true">close</span>
      </button>
    </div>
  );
}
